import { config } from "config";
import { AuthResponse, UserAgentApplication } from "msal";

const redirectUri = `${config.DOMAIN}/auth/microsoft/callback`;
const configAz = {
  auth: {
    clientId: config.AAD_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/common`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: false,
  },
};

const tokenConfig = {
  scopes: ["User.Read", "profile", "openid"],
};

export const auth = new UserAgentApplication(configAz);

export const getToken = (): Promise<string> =>
  new Promise((resolve, reject) => {
    auth.handleRedirectCallback((error, response) => {
      if (response?.idToken?.rawIdToken) {
        resolve(response.idToken.rawIdToken);
        return;
      }

      const account = auth.getAccount();
      if (!account) {
        reject(error || new Error("Microsoft login is required."));
        return;
      }

      auth
        .acquireTokenSilent({ ...tokenConfig, account })
        .then((data) => {
          resolve((data as AuthResponse).idToken.rawIdToken);
        })
        .catch(reject);
    });
  });
